import React, { useState } from 'react';

const EnrollmentTab = ({ filters }) => {
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});

  const tableData = [
    { id: 234, district: 'Шевченківський', age1_2: 234, age2_3: 221, age3_4: 132, age4_5: 111, age5_6: 97, age6_7: 197, age7_8: 166, total: 2201, total3_6: 1610 },
    { id: 235, district: 'Печерський', age1_2: 210, age2_3: 230, age3_4: 145, age4_5: 115, age5_6: 102, age6_7: 185, age7_8: 150, total: 2022, total3_6: 1560 },
    // ... остальные данные
  ];

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectedAll(isChecked);
    const newSelectedRows = {};
    if (isChecked) {
      tableData.forEach((_, index) => {
        newSelectedRows[index] = true;
      });
    }
    setSelectedRows(newSelectedRows);
  };

  const handleRowSelect = (index) => {
    setSelectedRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="publicstatistic-statistics-table-section">
      <h3 className="publicstatistic-section-title">
        Заявки на {filters.year} навчальний рік
      </h3>

      <div className="publicstatistic-table-responsive">
        <table className="table publicstatistic-statistics-table">
          <thead>
            <tr>
              <th style={{ width: '40px' }}>
                <input
                  type="checkbox"
                  className="publicstatistic-form-check-input publicstatistic-select-all-checkbox"
                  checked={selectedAll}
                  onChange={handleSelectAll}
                />
              </th>
              <th>№ садочка</th>
              <th>Район</th>
              <th>1-2 роки</th>
              <th>2-3 роки</th>
              <th>3-4 роки</th>
              <th>4-5 років</th>
              <th>5-6 років</th>
              <th>6-7 років</th>
              <th>Разом</th>
              <th>Разом 3-6</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    className="publicstatistic-form-check-input publicstatistic-row-checkbox"
                    checked={!!selectedRows[index]}
                    onChange={() => handleRowSelect(index)}
                  />
                </td>
                <td className="publicstatistic-district-name">{row.id}</td>
                <td>{row.district}</td>
                <td>{row.age1_2}</td>
                <td>{row.age2_3}</td>
                <td>{row.age3_4}</td>
                <td>{row.age4_5}</td>
                <td>{row.age5_6}</td>
                <td>{row.age6_7}</td>
                <td>{row.age7_8}</td>
                <td>{row.total}</td>
                <td>{row.total3_6}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EnrollmentTab;